import { AxiosError } from "axios";
import { userApi } from "../../apis/user.api";
import { getCookie } from "../utils/storage.util";

// Todo Error handling: https://dev.to/mperon/axios-error-handling-like-a-boss-333d
const errorHandler = (error: AxiosError) => {
  const statusCode = error.response?.status;

  // Logout and reload page if no permissions
  if (!error.config?.raw) {
    const token = getCookie("jwt-token");
    if (
      !document.location.pathname.endsWith("login") &&
      ((statusCode && statusCode === 401) || (token && statusCode === 403))
    ) {
      userApi.logout();
      window.location.reload();
    } else {
      // Todo: Error Handling
      console.error(error);
    }
  }

  return Promise.reject(error);
};

export default errorHandler;
